module.exports = __webpack_public_path__ + "42092f929161dae9c08a21bfb46ece4d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/yeoman.png
 ** module id = 228
 ** module chunks = 0
 **/